<template>
    <v-layout row wrap>
        <v-flex xs12 sm5 md6 lg5 class="pt-2">
            <span
                v-show="datePicker"
                :class="required ? '--required__label' : ''"
            >
                {{ datePickerLabel || $t('labels.selectDate') }}
            </span>
            <v-date-picker
                no-title
                locale="pt-BR"
                class="mt-2"
                v-show="datePicker"
                :value="date"
                prev-icon="bexsicon-left"
                next-icon="bexsicon-right"
                :allowed-dates="datePickerAllowedDates"
                :min="datePickerMinDate"
                :max="datePickerMaxDate"
                width="100%"
                @click:date="v => $emit('changeDate', v)"
            ></v-date-picker>
            <select-field
                v-show="!datePicker"
                :required="required"
                :label="dateSelectLabel || $t('labels.selectDate')"
                :placeholder="dateSelectPlaceholder || $t('labels.selectDate')"
                :value="date"
                :items="dateSelectItems"
                :selectKeyName="dateSelectKeyName"
                :selectValueName="dateSelectValueName"
                @change="v => $emit('changeDate', v)"
            ></select-field>
        </v-flex>
        <v-flex :class="`mt-2 xs12 ${datePicker ? 'sm7 md6 lg7' : ''}`">
            <span :class="'mx-2 ' + (required ? '--required__label' : '')">
                {{ scheduleLabel || $t('labels.selectTime') }}
            </span>
            <div class="schedule mt-2">
                <v-progress-circular
                    indeterminate
                    class="schedule__loader"
                    v-if="loadingSchedule"
                ></v-progress-circular>
                <span v-else>
                  <div>
                    <p
                        class="schedule__empty-state"
                        v-if="!!emptyState"
                    >
                        {{ emptyState }}
                    </p>
                    <span v-else>
                        <v-chip
                            :key="i"
                            v-for="(item, i) in schedule"
                            :disabled="!item.available"
                            :class="isScheduleSelected(item) ? selectedClass : ''"
                            @click="() => $emit('scheduleSelected', item)"
                        >
                            {{ getScheduleLabel(item)}}
                        </v-chip>
                    </span>
                  </div>
                </span>
            </div>
            <span class="mx-2" v-if="!loadingSchedule">
                {{ timezoneWarning || $t('labels.timezoneWarning') }}
            </span>
        </v-flex>
    </v-layout>
</template>
<script>
import SelectField from '@/components/fields/Select'

export default {
    name: 'schedule-field',
    components: {
        SelectField,
    },
    props: {
        required: {
            type: Boolean,
            default: false,
        },
        emptyState: {
            default: '',
        },
        datePicker: {
            type: Boolean,
            default: false,
        },
        datePickerLabel: {
            type: String,
            default: ''
        },
        dateSelectLabel: {
            type: String,
            default: ''
        },
        dateSelectPlaceholder: {
            type: String,
            default: ''
        },
        dateSelectItems: {
            type: Array,
            default: () => []
        },
        scheduleLabel: {
            type: String,
            default: ''
        },
        timezoneWarning: {
            type: String,
            default: ''
        },
        dateSelectKeyName: {
            type: String,
            default: 'value'
        },
        dateSelectValueName: {
            type: String,
            default: 'text'
        },
        loadingSchedule: {
            type: Boolean,
            default: false,
        },
        schedule: {
            type: Array,
            required: true,
        },
        date: {
            type: String,
        },
        isScheduleSelected: {
            type: Function,
            required: true
        },
        getScheduleLabel: {
            type: Function,
            required: true
        },
        selectedClass: {
            type: String,
            required: true
        },
        datePickerAllowedDates: {
            type: Function,
            default: () => true
        },
        datePickerMinDate: {
            type: String,
            default: ''
        },
        datePickerMaxDate: {
            type: String,
            default: ''
        }
    }
}
</script>
<style lang="scss" scoped>
.schedule {
    padding: 10px 15px;
    border: 1px solid #dcdcdc;
    border-radius: 5px;
    width: 100%;

    &__loader {
        color: var(--support-color);
        width: 50% !important;
        margin: 10% 25%;
    }

    &__empty-state {
        text-align: center;
        padding: 7.5% 10% 5%;
        color: var(--light-dark-color);
    }
}
</style>



// WEBPACK FOOTER //
// ./src/components/fields/Schedule.vue